module.exports = __webpack_public_path__ + "img/fabriqblog-original-1920.ba57fba3.png";